import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@moe/oss/ui/select";
import { cn } from "@moe/priv/utils";
import { useNavigate } from "@tanstack/react-router";
import { useSettingsMutation } from "@web/hooks/use-settings-mutation";
import { useComputedNSFW } from "@web/route-services/index/use-computed-nsfw";
import { useAppContext } from "@web/route-services/root/AppContext";
import { Route } from "@web/routes";

interface NSFWSelectorProps {
  className?: string;
}

export function NSFWSelector({ className }: NSFWSelectorProps) {
  const { session } = useAppContext();
  const nav = useNavigate({ from: Route.fullPath });
  const settingsMutation = useSettingsMutation({ showSuccessToast: false });
  const nsfwOK = useComputedNSFW();

  return (
    <Select
      value={nsfwOK ? "nsfw" : "sfw"}
      onValueChange={(value) => {
        const newNsfwOK = value === "nsfw";
        if (session) settingsMutation.mutate({ nsfwOK: newNsfwOK });
        nav({ search: (prev) => ({ ...prev, nsfwOK: newNsfwOK }) });
      }}
    >
      <SelectTrigger
        className={cn("text-tx-primary h-full w-fit justify-start border-none bg-transparent px-0", className)}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="sfw">SFW</SelectItem>
        <SelectItem value="nsfw">NSFW</SelectItem>
      </SelectContent>
    </Select>
  );
}
